import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import aboutHero from "../assets/about-hero.jpeg";
import "../styles/AboutHero.css";

const features = [
  { icon: "fa-solid fa-microchip",   label: "Advanced",  sub: "Technology"    },
  { icon: "fa-solid fa-chart-line",  label: "Accurate",  sub: "Results"       },
  { icon: "fa-solid fa-user-nurse",  label: "Qualified", sub: "Professionals" },
  { icon: "fa-solid fa-heart-pulse", label: "Patient",   sub: "Focused"       },
];

export default function AboutHero() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="abh-section" ref={sectionRef}>

      {/* ── RIGHT: diagonal-cut panel with 6px solid blue left border ── */}
      <div className="abh-right-bg">
        {/* Blue border strip — sits 6px behind/left of image clip edge */}
        <div className="abh-right-border" aria-hidden="true" />
        {/* Lab image clipped with same diagonal */}
        <div className="abh-img-wrap">
          <img src={aboutHero} alt="TANBIO Lab" loading="lazy" className="abh-hero-img" />
        </div>
      </div>

      {/* ── LEFT: content column ── */}
      <Container fluid className="abh-container px-4 px-lg-5">
        <div className="abh-inner">
          <Row className="w-100">
            <Col xs={12} lg={6} className="abh-left-col">

              <span className="abh-eyebrow">ABOUT US</span>

              <h1 className="abh-headline">
                About <span className="abh-brand">TANBIO</span>
                <span className="abh-headline-sub">Biomed Genomics Laboratory</span>
              </h1>

              <p className="abh-desc">
                TANBIO Biomed Genomics Laboratory is committed to providing accurate,
                reliable and timely diagnostic services with advanced technology and
                a patient-first approach.
              </p>

              {/*
                4 features — no card, no bg.
                Big icon on top, bold label, muted sub.
                Separated by vertical border-right dividers.
              */}
              <div className="abh-features">
                {features.map((f) => (
                  <div className="abh-feature-item" key={f.label}>
                    <div className="abh-feature-icon-wrap">
                      <i className={f.icon}></i>
                    </div>
                    <div className="abh-feature-text">
                      <span className="abh-feature-label">{f.label}</span>
                      <span className="abh-feature-sub">{f.sub}</span>
                    </div>
                  </div>
                ))}
              </div>

            </Col>
          </Row>
        </div>
      </Container>

    </section>
  );
}